export default "__VITE_ASSET__W7aBsNDN__"